import { Helmet } from "react-helmet";
import React, { Component } from "react";
import { Button, Table, Tabs, Tab, Form } from "react-bootstrap";
import axios from "axios";
import { apiHost } from "../../api/apiClient";
import Search from "../commoncomponents/Search";
import IconSelector from "../commoncomponents/IconSelector";
import { encodeQueryData } from "../../api/apiClient";
import Layout from "../../Layout/layout";
import { setLoadingPage, setErrorMessage } from "../../reducers/actions";
import { connect } from "react-redux";
import { utcToLocalOrFallback } from "../../utils/dateConvert";
import "../../styles/groups/groups.scss";

class EditGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      groupID: "",
      groupList: [],
      assetDetails: [],
      assetIdList: [],
      assetIdBoolean: false,
      userIdBoolean: false,
      userIdList: [],
      menusequence: "",
      defaultGroup: "",
      customerID: "default",
      name: "",
      description: "",
      color: "#",
      icon: "",
      status: "",
      customerID_error: false,
      name_error: false,
      userPageCount: 0,
      assetsPageCount: 0,
      //states for showing entries and total entries in page on Assets
      totalEntryA: 0,
      entryStartA: "1",
      entryEndA: "10",
      totalFilterA: false,
      totalEntryFilterA: "",
      filterMessageA: false,
      //states for showing entries and total entries in page on Users
      totalEntryU: 0,
      entryStartU: "1",
      entryEndU: "10",
      totalFilterU: false,
      totalEntryFilterU: "",
      filterMessageU: false,
      //user table sort
      sortStringUser: "name",
      sortDirectionUser: "asc",
      //Asser table sort
      sortString: "name",
      sortDirection: "asc",
      assetStatusFilter: "all",
      userStatusFilter: "all",
    };
    this.sortStringName = "name";
    this.sortDirection = "asc";
    this.sortStringNameUser = "name";
    this.sortDirectionUser = "asc";
    this.formSubmit = false;
    this.checkedAssets = [];
    this.assetsPageSize = "50";
    this.assetsSearchText = "";
    this.assetsPageKey = "1";
    this.usersPageSize = "50";
    this.usersSearchText = "";
    this.usersPageKey = "1";
    this.checkedUsers = [];
  }

  getIncludedElements = (data) => {
    if (!data) {
      return [];
    }

    const includedElements =
      data.includedelements ||
      data.includedElements ||
      data.Includedelements ||
      data.IncludedElements ||
      [];

    return Array.isArray(includedElements)
      ? includedElements.map((id) => id.toString())
      : [];
  };

  isSelected = (selectedIds, id) => {
    return selectedIds.map((selectedId) => selectedId.toString()).includes(id.toString());
  };

  toggleSelection = (selectedIds, id) => {
    const stringId = id.toString();
    return this.isSelected(selectedIds, stringId)
      ? selectedIds.filter((selectedId) => selectedId.toString() !== stringId)
      : [...selectedIds, stringId];
  };

  getEditContextTitle = () => {
    const customerName = this.state.groupList.customerName || "Customer";
    const groupName = this.state.name || this.state.groupList.name || "Group";

    return `${customerName} - ${groupName}`;
  };

  normalizeAssetStatus = (status) => {
    const normalizedStatus = (status || "").toString().trim().toLowerCase();

    if (normalizedStatus === "disable") {
      return "disabled";
    }

    return normalizedStatus;
  };

  normalizeUserStatus = (status) => {
    const normalizedStatus = (status || "").toString().trim().toLowerCase();

    if (normalizedStatus === "disable") {
      return "disabled";
    }

    return normalizedStatus || "active";
  };

  getAssetStatusCounts = () => {
    const counts = {
      all: this.state.assetDetails.length,
      active: 0,
      maintenance: 0,
      uninstalled: 0,
      disabled: 0,
      "waiting to be installed": 0,
    };

    this.state.assetDetails.forEach((asset) => {
      const status = this.normalizeAssetStatus(asset.status);
      if (Object.prototype.hasOwnProperty.call(counts, status)) {
        counts[status] += 1;
      }
    });

    return counts;
  };

  getFilteredAssetDetails = () => {
    const { assetDetails, assetStatusFilter } = this.state;

    if (assetStatusFilter === "all") {
      return assetDetails;
    }

    return assetDetails.filter(
      (asset) => this.normalizeAssetStatus(asset.status) === assetStatusFilter
    );
  };

  handleAssetStatusFilter = (assetStatusFilter) => {
    this.setState({ assetStatusFilter });
  };

  getUserStatusCounts = () => {
    const counts = {
      all: this.state.userIdList.length,
      active: 0,
      disabled: 0,
    };

    this.state.userIdList.forEach((user) => {
      const status = this.normalizeUserStatus(user.status);
      if (Object.prototype.hasOwnProperty.call(counts, status)) {
        counts[status] += 1;
      }
    });

    return counts;
  };

  getFilteredUserIdList = () => {
    const { userIdList, userStatusFilter } = this.state;

    if (userStatusFilter === "all") {
      return userIdList;
    }

    return userIdList.filter(
      (user) => this.normalizeUserStatus(user.status) === userStatusFilter
    );
  };

  handleUserStatusFilter = (userStatusFilter) => {
    this.setState({ userStatusFilter });
  };

  getAssetsEntryStart = () => {
    const totalEntry = parseInt(this.state.totalEntryA) || 0;
    if (totalEntry === 0) {
      return 0;
    }

    return (parseInt(this.assetsPageKey) - 1) * parseInt(this.assetsPageSize) + 1;
  };

  getAssetsEntryEnd = () => {
    const totalEntry = parseInt(this.state.totalEntryA) || 0;
    return Math.min(parseInt(this.assetsPageKey) * parseInt(this.assetsPageSize), totalEntry);
  };

  getUsersEntryStart = () => {
    const totalEntry = parseInt(this.state.totalEntryU) || 0;
    if (totalEntry === 0) {
      return 0;
    }

    return (parseInt(this.usersPageKey) - 1) * parseInt(this.usersPageSize) + 1;
  };

  getUsersEntryEnd = () => {
    const totalEntry = parseInt(this.state.totalEntryU) || 0;
    return Math.min(parseInt(this.usersPageKey) * parseInt(this.usersPageSize), totalEntry);
  };
  async componentDidMount() {
    console.log(this.props.match.params.id);
    let groupId = this.props.match.params.id;
    this.setState({ groupID: groupId });
    this.props.setLoadingPageAction(true);
    try {
      const groupList = await axios.get(
        `${apiHost}/api/Group/SelectGroup/${groupId}`,

        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      this.setState({ groupList: groupList.data });
      this.setState({
        customerID: groupList.data.customer_id,
        name: groupList.data.name,
        description: groupList.data.description,
        color: groupList.data.colour,
        icon: groupList.data.icon,
        status: groupList.data.status,
        menusequence: groupList.data.menuPriority,
        defaultGroup: groupList.data.menuDefault,
      });
      console.log("customer id", groupList.data);
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }

    let UrlAll = `${apiHost}/api/Group/AssetsByGroup/${groupId}?PageSize=50`;
    this.postAssets(UrlAll);

    let UrlUsers = `${apiHost}/api/Group/UsersByGroup/${groupId}?PageSize=50`;

    this.postUsers(UrlUsers);
    this.defaultGroupAutoCheck();
  }
  //Sort functionality of Assets table starts here

  handleSortString = (name) => {
    this.setState({
      sortString: name,
      sortDirection: "asc",
    });
    this.sortStringName = name;
    this.sortDirection = "asc";
    this.callback(name, this.sortDirection);
  };
  handleSortDirection = () => {
    if (this.state.sortDirection == "asc") {
      this.setState({
        sortDirection: "des",
      });
      this.sortDirection = "des";
    } else {
      this.setState({
        sortDirection: "asc",
      });
      this.sortDirection = "asc";
    }
    this.callback(this.sortStringName, this.sortDirection);
  };

  callback = (name, order) => {
    this.handleSort(name, order);
  };
  handleSort = (name, order) => {
    let groupId = this.props.match.params.id;
    this.sortString = name;
    this.sortDirection = order;
    console.log("name", this.sortString, "order", this.sortDirection);
    let query = encodeQueryData(this.setAssetsQueryObject());
    let urlAll = `${apiHost}/api/Group/AssetsByGroup/${groupId}?${query}`;

    this.postAssets(urlAll);
  };
  //Sort functionality of Assets table ends here
  //Sort functionality of user table starts here

  handleSortStringUser = (name) => {
    this.setState({
      sortStringUser: name,
      sortDirectionUser: "asc",
    });
    this.sortStringNameUser = name;
    this.sortDirectionUser = "asc";
    this.callbackUser(name, this.sortDirectionUser);
  };
  handleSortDirectionUser = () => {
    if (this.state.sortDirectionUser == "asc") {
      this.setState({
        sortDirectionUser: "des",
      });
      this.sortDirectionUser = "des";
    } else {
      this.setState({
        sortDirectionUser: "asc",
      });
      this.sortDirectionUser = "asc";
    }
    this.callbackUser(this.sortStringNameUser, this.sortDirectionUser);
  };

  callbackUser = (name, order) => {
    this.sortFunctionUser(name, order);
  };
  sortFunctionUser = (name, order) => {
    let groupId = this.props.match.params.id;
    this.sortStringUser = name;
    this.sortDirectionUser = order;
    console.log("name", this.sortStringUser, "order", this.sortDirectionUser);
    let query = encodeQueryData(this.setUsersQueryObject());

    console.log("query user noject", query);
    let urlAll = `${apiHost}/api/Group/UsersByGroup/${groupId}?${query}`;
    this.postUsers(urlAll);
  };
  //Sort functionality of user table ends here

  defaultGroupAutoCheck = () => {
    var checkBox = document.getElementById("defaultGroup");
    if (this.state.defaultGroup == 1) {
      checkBox.checked = true;
    }
  };
  handleDefaultGroup = () => {
    var checkBox = document.getElementById("defaultGroup");
    if (checkBox.checked) {
      this.setState({ defaultGroup: 1 });
    } else {
      this.setState({ defaultGroup: 0 });
    }
  };
  handleMenuSequence = (e) => {
    console.log(e.target.value);
    this.setState({
      menusequence: e.target.value,
    });
  };

  handleSearch = (inputSearch) => {
    //filtered by message on showing results
    if (inputSearch == "") {
      this.setState({ filterMessageA: false });
    } else {
      this.setState({ filterMessageA: true });
    }
    let groupId = this.props.match.params.id;
    this.assetsSearchText = inputSearch;
    this.assetsPageKey = "1";
    let query = encodeQueryData(this.setAssetsQueryObject());
    let urlAll = `${apiHost}/api/Group/AssetsByGroup/${groupId}?${query}`;
    this.postAssets(urlAll);
  };

  handleShowEntries = (inputShowEntries) => {
    let groupId = this.props.match.params.id;
    console.log(inputShowEntries);
    this.assetsPageSize = inputShowEntries;
    this.assetsPageKey = "1";
    let query = encodeQueryData(this.setAssetsQueryObject());
    let urlAll = `${apiHost}/api/Group/AssetsByGroup/${groupId}?${query}`;
    this.postAssets(urlAll);
  };

  setAssetsQueryObject = () => {
    let data = {};
    data.SearchString = this.assetsSearchText;
    data.PageSize = this.assetsPageSize;
    data.PageNumber = this.assetsPageKey;
    data.SortDirection = this.sortDirection;
    data.SortString = this.sortString;
    return data;
  };
  handleAssetsPagination = (page) => {
    let groupId = this.props.match.params.id;

    this.assetsPageKey = page;
    let query = encodeQueryData(this.setAssetsQueryObject());
    let urlAll = `${apiHost}/api/Group/AssetsByGroup/${groupId}?${query}`;

    this.postAssets(urlAll);
  };

  handleUserSearch = (inputSearch) => {
    //filtered by message on showing results
    if (inputSearch == "") {
      this.setState({ filterMessageU: false });
    } else {
      this.setState({ filterMessageU: true });
    }
    let groupId = this.props.match.params.id;
    this.usersSearchText = inputSearch;
    this.usersPageKey = "1";
    let query = encodeQueryData(this.setUsersQueryObject());
    let urlAll = `${apiHost}/api/Group/UsersByGroup/${groupId}?${query}`;
    this.postUsers(urlAll);
  };

  handleUserShowEntries = (inputShowEntries) => {
    let groupId = this.props.match.params.id;
    console.log(inputShowEntries);
    this.usersPageSize = inputShowEntries;
    this.usersPageKey = "1";
    let query = encodeQueryData(this.setUsersQueryObject());
    let urlAll = `${apiHost}/api/Group/UsersByGroup/${groupId}?${query}`;
    this.postUsers(urlAll);
  };

  setUsersQueryObject = () => {
    let data = {};
    data.SearchString = this.usersSearchText;
    data.PageSize = this.usersPageSize;
    data.PageNumber = this.usersPageKey;
    data.SortDirection = this.sortDirectionUser;
    data.SortString = this.sortStringUser;
    return data;
  };

  handleUsersPagination = (page) => {
    let groupId = this.props.match.params.id;

    this.usersPageKey = page;
    let query = encodeQueryData(this.setUsersQueryObject());
    let urlAll = `${apiHost}/api/Group/UsersByGroup/${groupId}?${query}`;

    this.postUsers(urlAll);
  };

  handleShowAssetsResults = (response) => {
    // function for showing entries and total entries in page
    const pagination = JSON.parse(response.headers.pagination);
    const totalItems = pagination.totalItems || 0;
    const currentPage = pagination.currentPage || parseInt(this.assetsPageKey);
    const pageSize = parseInt(this.assetsPageSize);
    const assetRows = response.data && response.data.paggedlist
      ? response.data.paggedlist
      : [];
    const entryStart = totalItems === 0 ? 0 : (currentPage - 1) * pageSize + 1;
    const entryEnd = Math.min(currentPage * pageSize, totalItems);

    if (!this.state.totalFilterA) {
      this.setState({
        totalEntryFilterA: totalItems,
        totalFilterA: true,
      });
    }

    if (assetRows.length === 0) {
      this.setState({ entryStartA: "0", entryEndA: "0", totalEntryA: "0" });
    } else {
      this.setState({
        entryStartA: entryStart,
        entryEndA: entryEnd,
        totalEntryA: totalItems,
      });
    }
  };

  handleShowUsersResults = (response) => {
    // function for showing entries and total entries in page
    const pagination = JSON.parse(response.headers.pagination);
    const totalItems = pagination.totalItems || 0;
    const currentPage = pagination.currentPage || parseInt(this.usersPageKey);
    const pageSize = parseInt(this.usersPageSize);
    const userRows = response.data && response.data.paggedlist
      ? response.data.paggedlist
      : [];
    const entryStart = totalItems === 0 ? 0 : (currentPage - 1) * pageSize + 1;
    const entryEnd = Math.min(currentPage * pageSize, totalItems);

    if (!this.state.totalFilterU) {
      this.setState({
        totalEntryFilterU: totalItems,
        totalFilterU: true,
      });
    }

    if (userRows.length === 0) {
      this.setState({ entryStartU: "0", entryEndU: "0", totalEntryU: "0" });
    } else {
      this.setState({
        entryStartU: entryStart,
        entryEndU: entryEnd,
        totalEntryU: totalItems,
      });
    }
  };
  postAssets = async (url) => {
    this.props.setLoadingPageAction(true);
    try {
      let assetDetails = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      console.log("assetDetails", assetDetails);
      this.setState({
        assetDetails: assetDetails.data.paggedlist,
        assetsPageCount: JSON.parse(assetDetails.headers.pagination).totalPages,
        totalEntryA: JSON.parse(assetDetails.headers.pagination).totalItems,
      });
      if (!this.state.assetIdBoolean) {
        this.checkedAssets = this.getIncludedElements(assetDetails.data);
        this.setState({ assetIdBoolean: true });
      }
      this.handleShowAssetsResults(assetDetails);
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
    this.forceUpdate();
  };

  postUsers = async (url) => {
    this.props.setLoadingPageAction(true);
    try {
      let userIdList = await axios.post(
        url,
        {},
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      console.log("userIdList", userIdList);
      this.setState({
        userIdList: userIdList.data.paggedlist,
        userPageCount: JSON.parse(userIdList.headers.pagination).totalPages,
        totalEntryU: JSON.parse(userIdList.headers.pagination).totalItems,
      });
      if (!this.state.userIdBoolean) {
        this.checkedUsers = this.getIncludedElements(userIdList.data);
        this.setState({ userIdBoolean: true });
      }
      this.handleShowUsersResults(userIdList);
      this.props.setLoadingPageAction(false);
    } catch (e) {
      if (e.response.status == "401") {
        this.props.history.push("/login");
      } else {
        this.props.setErrorMessageAction(`${e}`);
      }
      this.props.setLoadingPageAction(false);

      console.log(`😱 Axios request failed: ${e}`);
    }
    this.forceUpdate();
  };

  handleNameChange(e) {
    console.log("e.target.value", e.target.value);
    if (e.target.value == "") {
      this.setState({ name_error: true });
    } else {
      this.setState({ name_error: false });
    }
    this.setState({ name: e.target.value });
  }
  handleColorChange = (e) => {
    this.setState({ color: e.target.value });
  };

  getColorPickerValue = () => {
    const color = String(this.state.color || "").trim();
    return /^#[0-9a-fA-F]{6}$/.test(color) ? color : "#160f9e";
  };
  handleDescriptionChange(e) {
    this.setState({ description: e.target.value });
  }
  handleConfirmIconChange(e) {
    this.setState({ icon: e.target.value });
  }

  handleIconSelection = (icon) => {
    this.setState({ icon });
  }

  handleVisualDefaults = () => {
    this.setState({
      color: "#160f9e",
      icon: "fa fa-truck",
    });
  }
  handleStatusChange(e) {
    this.setState({ status: e.target.value });
    console.log(e.target.value);
  }

  async handleSubmit() {
    this.formSubmit = true;
    if (this.state.customerID == "default") {
      this.setState({ customerID_error: true });
      this.formSubmit = false;
    }

    if (this.state.name == "") {
      this.setState({ name_error: true });
      this.formSubmit = false;
    }

    if (this.formSubmit) {
      this.props.setLoadingPageAction(true);

      try {
        const response = await axios.post(
          `${apiHost}/api/Group/UpdateGroup`,
          {
            Id: this.state.groupList.id,
            Name: this.state.name,
            CustomerId: this.state.groupList.customerId,
            Description: this.state.description,
            Colour: this.state.color,
            Icon: this.state.icon,
            Status: this.state.status,
            AssetIds: this.checkedAssets,
            UserIds: this.checkedUsers,
            dbUpdated: this.state.groupList.dbUpdated,
            dbCreated: this.state.groupList.dbCreated,
            MenuDefault: this.state.defaultGroup,
            MenuPriority: this.state.menusequence,
          },
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        );
        //  this.props.history.push("/groups");
        this.props.history.goBack();
        console.log("customer id", response.data);
        this.props.setLoadingPageAction(false);
      } catch (e) {
        if (e.response.status == "401") {
          this.props.history.push("/login");
        } else {
          this.props.setErrorMessageAction(`${e}`);
        }
        this.props.setLoadingPageAction(false);

        console.log(`😱 Axios request failed: ${e}`);
      }
    }
  }

  handleCheck = (assets) => {
    this.checkedAssets = this.toggleSelection(this.checkedAssets, assets);
    this.forceUpdate();
    console.log("checked assets array", this.checkedAssets);
  };
  handleUserCheck = (assets) => {
    this.checkedUsers = this.toggleSelection(this.checkedUsers, assets);
    this.forceUpdate();
    console.log("checked assets array", this.checkedUsers);
  };

  render() {
    const { groupList } = this.state;
    const arr = [50, 100, 1000000];
    const filteredAssetDetails = this.getFilteredAssetDetails();
    const filteredUserIdList = this.getFilteredUserIdList();
    const assetStatusCounts = this.getAssetStatusCounts();
    const userStatusCounts = this.getUserStatusCounts();
    const isUserStatusFiltered = this.state.userStatusFilter !== "all";
    const usersEntryStart = isUserStatusFiltered
      ? (filteredUserIdList.length === 0 ? 0 : 1)
      : this.getUsersEntryStart();
    const usersEntryEnd = isUserStatusFiltered
      ? filteredUserIdList.length
      : this.getUsersEntryEnd();
    const usersEntryTotal = isUserStatusFiltered
      ? filteredUserIdList.length
      : this.state.totalEntryU;
    const assetStatusFilters = [
      { key: "all", label: "All", count: assetStatusCounts.all },
      { key: "active", label: "Active", count: assetStatusCounts.active },
      {
        key: "maintenance",
        label: "Maintenance",
        count: assetStatusCounts.maintenance,
      },
      {
        key: "uninstalled",
        label: "Uninstalled",
        count: assetStatusCounts.uninstalled,
      },
      { key: "disabled", label: "Disabled", count: assetStatusCounts.disabled },
      {
        key: "waiting to be installed",
        label: "Waiting to be installed",
        count: assetStatusCounts["waiting to be installed"],
      },
    ];
    const userStatusFilters = [
      { key: "all", label: "All", count: userStatusCounts.all },
      { key: "active", label: "Active", count: userStatusCounts.active },
      { key: "disabled", label: "Disabled", count: userStatusCounts.disabled },
    ];
    console.log("asset details,...", this.state.assetDetails);
    return (
      <div>
        <Layout>
          <Helmet>
            <title>Edit Group </title>
          </Helmet>

          <div className="contentBodyEditGroup">
            <div className="contentWrapper group-edit-page">
              <div className="group-edit-header">
                <div className="group-edit-heading-row">
                  <div>
                    <span className="group-edit-kicker">Edit Group</span>
                    <h2>{this.getEditContextTitle()}</h2>
                    <div className="group-edit-header-badges">
                      {groupList.customerName && <span>{groupList.customerName}</span>}
                      {this.state.status && (
                        <span className={this.state.status === "Active" ? "record-badge-active" : "record-badge-disabled"}>
                          {this.state.status === "Active" ? "Active" : "Disabled"}
                        </span>
                      )}
                    </div>
                    <p>Review details, assets and members for this group.</p>
                  </div>
                  <div className="group-edit-actions group-edit-actions-header">
                    <Button
                      size="sm"
                      variant="outline-secondary"
                      onClick={() => {
                        //this.props.history.push("/groups");
                        this.props.history.goBack();
                      }}
                    >
                      Back to List
                    </Button>
                    <Button
                      size="sm"
                      variant="primary"
                      onClick={this.handleSubmit.bind(this)}
                    >
                      Save Changes
                    </Button>
                  </div>
                </div>
              </div>
              <Tabs id="group-edit-tabs" className="group-edit-tabs">
                <Tab eventKey="details" title="Details">
                  <div className="groupEditDetail">
                    <Form className="group-create-form-modern group-edit-details-form">
                      <section className="group-create-section">
                        <div className="group-create-section-title">
                          <h3>Group Identity</h3>
                          <p>Customer ownership, group name and descriptive details.</p>
                        </div>
                        <div className="group-create-grid">
                          <Form.Group controlId="groupCustomer">
                            <Form.Label>Customer</Form.Label>
                            <div className="group-edit-readonly-card">
                              {groupList.customerName}
                            </div>
                            <p className={this.state.customerID_error ? "group-create-error" : "group-create-error hidden"}>
                              The Customer field is required.
                            </p>
                          </Form.Group>

                          <Form.Group controlId="groupName">
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                              type="text"
                              value={this.state.name}
                              onChange={this.handleNameChange.bind(this)}
                            />
                            <p className={this.state.name_error ? "group-create-error" : "group-create-error hidden"}>
                              The Name field is required.
                            </p>
                          </Form.Group>

                          <Form.Group className="group-create-wide" controlId="groupDescription">
                            <Form.Label>Description</Form.Label>
                            <Form.Control
                              as="textarea"
                              value={this.state.description}
                              onChange={this.handleDescriptionChange.bind(this)}
                              rows="3"
                            />
                          </Form.Group>
                        </div>
                      </section>

                      <section className="group-create-section">
                        <div className="group-create-section-title">
                          <h3>Visual Settings</h3>
                          <p>Colour and icon used when this group appears in the platform.</p>
                        </div>
                        <div className="group-create-grid">
                          <Form.Group controlId="groupColour">
                            <Form.Label>Colour</Form.Label>
                            <div className="colour-picker-field">
                              <Form.Control
                                type="color"
                                value={this.getColorPickerValue()}
                                onChange={this.handleColorChange.bind(this)}
                                title="Choose colour"
                              />
                              <Form.Control
                                type="text"
                                value={this.state.color}
                                onChange={this.handleColorChange.bind(this)}
                              />
                            </div>
                          </Form.Group>

                          <Form.Group className="group-create-wide" controlId="groupIcon">
                            <Form.Label>Icon</Form.Label>
                            <IconSelector
                              value={this.state.icon}
                              onChange={this.handleIconSelection}
                            />
                            <div className="group-create-icon-row">
                              <Form.Control
                                type="text"
                                value={this.state.icon}
                                onChange={this.handleConfirmIconChange.bind(this)}
                              />
                              <button type="button" className="visual-default-button" onClick={this.handleVisualDefaults}>
                                Back to default
                              </button>
                            </div>
                          </Form.Group>
                        </div>
                      </section>

                      <section className="group-create-section">
                        <div className="group-create-section-title">
                          <h3>Availability</h3>
                          <p>Set group status, menu order and default group behaviour.</p>
                        </div>
                        <div className="group-create-grid">
                          <Form.Group controlId="defaultGroup">
                            <Form.Label>Default Group</Form.Label>
                            <label className="group-edit-toggle-row">
                              <input
                                type="checkbox"
                                id="defaultGroup"
                                checked={this.state.defaultGroup == 1}
                                onChange={this.handleDefaultGroup}
                              />
                              <span>{this.state.defaultGroup == 1 ? "Enabled" : "Disabled"}</span>
                            </label>
                          </Form.Group>

                          <Form.Group controlId="groupMenuSequence">
                            <Form.Label>Menu Sequence</Form.Label>
                            <Form.Control
                              type="number"
                              value={this.state.menusequence}
                              onChange={this.handleMenuSequence}
                            />
                          </Form.Group>

                          <Form.Group controlId="groupStatus">
                            <Form.Label>Status</Form.Label>
                            <Form.Control
                              as="select"
                              value={this.state.status}
                              onChange={this.handleStatusChange.bind(this)}
                            >
                              <option value="Active">Active</option>
                              <option value="Disable">Disabled</option>
                            </Form.Control>
                          </Form.Group>
                        </div>
                      </section>

                    </Form>
                  </div>
                </Tab>
                <Tab
                  eventKey="assets"
                  title={
                    <span className="group-tab-title">
                      Assets <strong>{this.checkedAssets.length}</strong>
                    </span>
                  }
                >
                  <div className="group-edit-table-toolbar">
                    <div className="group-status-filter group-asset-status-filter" aria-label="Asset status filter">
                      <span>Asset status filter</span>
                      <div>
                        {assetStatusFilters.map((filter) => (
                          <button
                            className={
                              this.state.assetStatusFilter === filter.key
                                ? "active"
                                : ""
                            }
                            key={filter.key}
                            onClick={() => this.handleAssetStatusFilter(filter.key)}
                            type="button"
                          >
                            {filter.label}
                            <strong>{filter.count}</strong>
                          </button>
                        ))}
                      </div>
                    </div>
                    <Search
                      debounceMs={350}
                      searchCallback={this.handleSearch}
                    ></Search>
                  </div>
                  <Table className="group-selection-table group-users-table" responsive>
                    <thead>
                      <tr>
                        <th></th>
                        <th>
                          Name{" "}
                          {this.state.sortString == "name" ? (
                            <i
                              onClick={this.handleSortDirection}
                              className={`fa ${this.state.sortDirection == "asc"
                                ? "fa-sort-amount-asc"
                                : "fa-sort-amount-desc"
                                }`}
                            />
                          ) : (
                            <i
                              className="fa fa-exchange"
                              onClick={() => {
                                this.handleSortString("name");
                              }}
                            />
                          )}
                        </th>
                        <th>
                          Tag1{" "}
                          {this.state.sortString == "tag1" ? (
                            <i
                              onClick={this.handleSortDirection}
                              className={`fa ${this.state.sortDirection == "asc"
                                ? "fa-sort-amount-asc"
                                : "fa-sort-amount-desc"
                                }`}
                            />
                          ) : (
                            <i
                              className="fa fa-exchange"
                              onClick={() => {
                                this.handleSortString("tag1");
                              }}
                            />
                          )}
                        </th>
                        <th>
                          Tag2{" "}
                          {this.state.sortString == "tag2" ? (
                            <i
                              onClick={this.handleSortDirection}
                              className={`fa ${this.state.sortDirection == "asc"
                                ? "fa-sort-amount-asc"
                                : "fa-sort-amount-desc"
                                }`}
                            />
                          ) : (
                            <i
                              className="fa fa-exchange"
                              onClick={() => {
                                this.handleSortString("tag2");
                              }}
                            />
                          )}
                        </th>
                        <th>Description </th>
                        <th>
                          Status{" "}
                          {this.state.sortString == "status" ? (
                            <i
                              onClick={this.handleSortDirection}
                              className={`fa ${this.state.sortDirection == "asc"
                                ? "fa-sort-amount-asc"
                                : "fa-sort-amount-desc"
                                }`}
                            />
                          ) : (
                            <i
                              className="fa fa-exchange"
                              onClick={() => {
                                this.handleSortString("status");
                              }}
                            />
                          )}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredAssetDetails.map((assets, index) => {
                        const isAssetSelected = this.isSelected(
                          this.checkedAssets,
                          assets.id
                        );
                        return (
                          <tr
                            value={assets.id}
                            id={`tr-${assets.id}`}
                            className={isAssetSelected ? "selected" : ""}
                            onClick={(e) => {
                              this.handleCheck(assets.id);
                            }}
                          >
                            <td>
                              <input
                                type="checkbox"
                                id={assets.id}
                                value={assets.id}
                                checked={isAssetSelected}
                                readOnly
                                className="tr-checkBox"
                                style={{ pointerEvents: "none" }}
                              />
                            </td>
                            <td>{assets.name}</td>
                            <td>{assets.tag1}</td>
                            <td>{assets.tag2}</td>
                            <td>{assets.description}</td>

                            <td>{assets.status}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                  <div className="paginationDetails">
                    <div className="group-pagination group-edit-pagination">
                      <div>
                        Showing <strong>{this.getAssetsEntryStart()}</strong> to{" "}
                        <strong>{this.getAssetsEntryEnd()}</strong> of{" "}
                        <strong>{this.state.totalEntryA}</strong> assets
                      </div>
                      <div className="group-pagination-actions">
                        <label>
                          Rows
                          <select
                            value={this.assetsPageSize}
                            onChange={(e) => this.handleShowEntries(e.target.value)}
                          >
                            {arr.map((size) => (
                              <option key={size} value={size}>
                                {size == 1000000 ? "All" : size}
                              </option>
                            ))}
                          </select>
                        </label>
                        <button
                          disabled={parseInt(this.assetsPageKey) <= 1}
                          onClick={() => this.handleAssetsPagination(parseInt(this.assetsPageKey) - 1)}
                          type="button"
                        >
                          Previous
                        </button>
                        <span>
                          Page <strong>{this.assetsPageKey}</strong> of{" "}
                          <strong>{this.state.assetsPageCount || 1}</strong>
                        </span>
                        <button
                          disabled={parseInt(this.assetsPageKey) >= (this.state.assetsPageCount || 1)}
                          onClick={() => this.handleAssetsPagination(parseInt(this.assetsPageKey) + 1)}
                          type="button"
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                </Tab>
                <Tab
                  eventKey="members"
                  title={
                    <span className="group-tab-title">
                      Users <strong>{this.checkedUsers.length}</strong>
                    </span>
                  }
                >
                  <div className="group-edit-table-toolbar">
                    <div className="group-status-filter group-user-status-filter" aria-label="User status filter">
                      <span>User status filter</span>
                      <div>
                        {userStatusFilters.map((filter) => (
                          <button
                            className={
                              this.state.userStatusFilter === filter.key
                                ? "active"
                                : ""
                            }
                            key={filter.key}
                            onClick={() => this.handleUserStatusFilter(filter.key)}
                            type="button"
                          >
                            {filter.label}
                            <strong>{filter.count}</strong>
                          </button>
                        ))}
                      </div>
                    </div>
                    <Search
                      debounceMs={350}
                      searchCallback={this.handleUserSearch}
                    ></Search>
                  </div>
                  <Table className="group-selection-table" responsive>
                    <thead>
                      <tr>
                        <th></th>
                        <th>
                          Name{" "}
                          {this.state.sortStringUser == "name" ? (
                            <i
                              onClick={this.handleSortDirectionUser}
                              className={`fa ${this.state.sortDirectionUser == "asc"
                                ? "fa-sort-amount-asc"
                                : "fa-sort-amount-desc"
                                }`}
                            />
                          ) : (
                            <i
                              className="fa fa-exchange"
                              onClick={() => {
                                this.handleSortStringUser("name");
                              }}
                            />
                          )}{" "}
                        </th>
                        <th>
                          Email{" "}
                          {this.state.sortStringUser == "email" ? (
                            <i
                              onClick={this.handleSortDirectionUser}
                              className={`fa ${this.state.sortDirectionUser == "asc"
                                ? "fa-sort-amount-asc"
                                : "fa-sort-amount-desc"
                                }`}
                            />
                          ) : (
                            <i
                              className="fa fa-exchange"
                              onClick={() => {
                                this.handleSortStringUser("email");
                              }}
                            />
                          )}{" "}
                        </th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredUserIdList.map((users, index) => {
                        const isUserSelected = this.isSelected(
                          this.checkedUsers,
                          users.id
                        );
                        const userStatus = users.status || "Active";
                        return (
                          <tr
                            value={users.id}
                            id={`truser-${users.id}`}
                            className={isUserSelected ? "selected" : ""}
                            onClick={(e) => {
                              this.handleUserCheck(users.id);
                            }}
                          >
                            <td>
                              <input
                                type="checkbox"
                                id={users.id}
                                value={users.id}
                                checked={isUserSelected}
                                readOnly
                                className="tr-usercheckBox"
                                style={{ pointerEvents: "none" }}
                              />
                            </td>
                            <td>{users.userName}</td>
                            <td>{users.email}</td>
                            <td>
                              <span className={`group-user-status group-user-status-${this.normalizeUserStatus(userStatus)}`}>
                                {userStatus}
                              </span>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                  <div className="paginationDetails">
                    <div className="group-pagination group-edit-pagination">
                      <div>
                        Showing <strong>{usersEntryStart}</strong> to{" "}
                        <strong>{usersEntryEnd}</strong> of{" "}
                        <strong>{usersEntryTotal}</strong> users
                      </div>
                      <div className="group-pagination-actions">
                        <label>
                          Rows
                          <select
                            value={this.usersPageSize}
                            onChange={(e) => this.handleUserShowEntries(e.target.value)}
                          >
                            {arr.map((size) => (
                              <option key={size} value={size}>
                                {size == 1000000 ? "All" : size}
                              </option>
                            ))}
                          </select>
                        </label>
                        <button
                          disabled={parseInt(this.usersPageKey) <= 1}
                          onClick={() => this.handleUsersPagination(parseInt(this.usersPageKey) - 1)}
                          type="button"
                        >
                          Previous
                        </button>
                        <span>
                          Page <strong>{this.usersPageKey}</strong> of{" "}
                          <strong>{this.state.userPageCount || 1}</strong>
                        </span>
                        <button
                          disabled={parseInt(this.usersPageKey) >= (this.state.userPageCount || 1)}
                          onClick={() => this.handleUsersPagination(parseInt(this.usersPageKey) + 1)}
                          type="button"
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                </Tab>
              </Tabs>
              <div className="group-edit-meta">
                <div>
                  <span>Created</span>
                  <strong>{utcToLocalOrFallback(groupList.dbCreated)}</strong>
                </div>
                <div>
                  <span>Updated</span>
                  <strong>{utcToLocalOrFallback(groupList.dbUpdated)}</strong>
                </div>
              </div>
              <div className="footer-menu group-edit-actions">
                <Button
                  size="sm"
                  variant="outline-secondary"
                  onClick={() => {
                    //this.props.history.push("/groups");
                    this.props.history.goBack();
                  }}
                >
                  Back to List
                </Button>
                <Button
                  size="sm"
                  variant="primary"
                  onClick={this.handleSubmit.bind(this)}
                >
                  Save Changes
                </Button>
              </div>
            </div>
          </div>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.loading,
});
const mapDispatchToProps = {
  setLoadingPageAction: setLoadingPage,
  setErrorMessageAction: setErrorMessage,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditGroup);
